// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "90de42fc" + "." + "a11b3bf646c29f95" + ".js";
};